module.exports = __webpack_public_path__ + "img/yello.6a594664.png";